import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: 20,
    backgroundColor: white,
  },
});
